import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { RouteDataService } from '../../services/route-data.service';
import { Point } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { DOTTED_POLYLINE, BLUE_SOLID_POLYLINE, RED_SOLID_POLYLINE, BORDER_POLYLINE } from './config/constants';

@Component({
    selector: 'fitur-map-polylines',
    standalone: true,
    imports: [ 
        CommonModule, 
        GoogleMapsModule
    ],
    templateUrl: './polylines.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class FiturMapPolylinesComponent {
    private _routeDataService: RouteDataService = inject(RouteDataService);
    public currentRouteDay = computed<Point[]>(() => this._routeDataService.getCurrentRouteDay());
    
    // public currentRouteDay = computed<Point[]>(() => {
    //     const polylines = this._routeDataService.getCurrentRouteDay()?.map((marker, indexMarker) => {
    //         const routeLength = this._routeDataService.getCurrentRouteDay()?.length;
    //         if (indexMarker === 0 || indexMarker === routeLength - 1 || indexMarker === Math.trunc(routeLength/2)){
    //             const [a, b, c] = this.splitInto3(marker.polylinesPath);
    //             return { ...marker, fiturPolylinesPath: { bus: a, metro: b, walking: c }}
    //         }
    //         return { ...marker, fiturPolylinesPath: { bus: [], metro: [], walking: [] }}
    //     });
    //     return polylines;
    // });

    public blueSolidPolylineOptions: google.maps.PolylineOptions = BLUE_SOLID_POLYLINE();
    public redSolidPolylineOptions: google.maps.PolylineOptions = RED_SOLID_POLYLINE();
    public borderPolylineOptions: google.maps.PolylineOptions = BORDER_POLYLINE();
    public dottedPolylineOptions: google.maps.PolylineOptions = DOTTED_POLYLINE();

    public isFiturPolylines(item){
        return item?.fiturPolylinesPath?.bus?.length
            || item?.fiturPolylinesPath?.metro?.length
            || item?.fiturPolylinesPath?.walking?.length
    }

    private splitInto3(arr) {
        const n = arr.length;
        const base = Math.floor(n / 3);
        const extra = n % 3; 

        const sizes = [
            base + (extra > 0 ? 1 : 0),
            base + (extra > 1 ? 1 : 0),
            base
        ];

        const a = arr.slice(0, sizes[0]);
        const b = arr.slice(sizes[0], sizes[0] + sizes[1]);
        const c = arr.slice(sizes[0] + sizes[1]);

        return [a, b, c];
    }

    swapLatLng(path: Array<{lat:number; lng:number}> = []) {
        return path.map(p => ({ lat: p.lng, lng: p.lat }));
    }

}